import axios from "axios";

function API_AUTH() {
    return axios.create({
      baseURL: process.env.REACT_APP_BASE_URL,
      headers: { Authorization: `Bearer ${window.token}` },
    });
  }

export default API_AUTH;